import { JobOfferStateEnum, MesgSearchFilter, MessagesWhereInput, QueryFilter } from '@dinosband/bv-messenger-schema'
import { mainStore } from '@dinosband/bv-utils'
import { _difference, _merge } from '@dinosband/dbi-utils'
import { _resolveLocations } from '../../utils'
import { ExcludeDeleteReasons } from './const'

export function messageQueryFilter (filter?: QueryFilter) {
  const where: MessagesWhereInput = {}
  const mesgFilter = filter as MesgSearchFilter | undefined
  const NONE = '--'

  if (mesgFilter) {
    if (mesgFilter.keywords?.length || mesgFilter.searchKeywords?.length) {
      where.keywords = _merge(mesgFilter.keywords, mesgFilter.searchKeywords)
    }
    if (mesgFilter.matchKeywords.flat().length) {
      const excludes = [...mesgFilter.excludeKeywords || [], NONE]
      const keywords = mesgFilter.matchKeywords.map((i) => _difference(i, excludes)).filter((i) => i.length)
      if (keywords.length) {
        where.AND = keywords.map((i) => ({ analyzedKeywords: { in: i } }))
      }
    }
    if (mesgFilter.locations.length && mesgFilter.locations[0] !== NONE) {
      const locationsIn = _resolveLocations(mesgFilter.locations)
      where.AND = [...where.AND ?? [], { locations: { in: locationsIn } }]
    }
    if (mesgFilter.searchLocations?.length) {
      where.advancedLocations = mesgFilter.searchLocations
    }
    if (mesgFilter.createdAfter) {
      //TODO: implement createdAfter
    }
    if (mesgFilter.excludeKeywords?.length) {
      where.AND = [...where.AND ?? [], { analyzedKeywords: { notIn: mesgFilter.excludeKeywords } }]
    }
    if (mesgFilter.excludeFinished) {
      where.jobOfferState = { notIn: [JobOfferStateEnum.Hired] }
    }
    if (mesgFilter.onlyOwnMessages) {
      where.userId = mainStore.userId
      if (mesgFilter.includeByAdmin) {
        where.byAdmin = true
      }
    }
  }

  if (mesgFilter?.excludeDeleted) {
    where.isDeleted = false
  } else {
    where.deleteReason = { notIn: ExcludeDeleteReasons }
  }

  const blockedProfileIds = mainStore.blockedProfileIds
  if (blockedProfileIds.length) {
    where.profileId = { notIn: blockedProfileIds }
  }

  // if (!option?.filterOwnMessages && where.AND?.length) {
  //   const myProfileIds = mainStore.profileIds
  //   if (myProfileIds.length) {
  //     where = {
  //       OR: [
  //         { profileIds: { in: myProfileIds } },
  //         { AND: where.AND },
  //       ],
  //     }
  //   }
  // }
  return where
}
